<template>
  <div class="skill">
    <div class="skill-section" v-for="item in showSkillGroup" :key="item?.labelName">
        <div class="skill-label">
            <img
                :src="item?.labelUrl"
            />
            <span>{{ item.labelName }}</span>
        </div>
        <div>
            {{ item.content }}
        </div>
    </div>
    <!-- <div class="skill-section" style="color: #F5F5F5">
        With rich experience, they will become more adept at handling Terra, and can even crystallize ARG like Yuli.
    </div> -->
    <div class="skill-section">
        <div class="table" v-for="(row, index) in tableData" :key="index">
            <div class="row" v-for="item in row" :key="item" :class="[{'odd': index % 2 != 0}]">
                {{ item }}
            </div>
        </div>
    </div>
    <div class="skill-section">
      {{ showTableBottomDesc }}
    </div>
    <div style="width: 100%;height: 40px;"></div>
  </div>
</template>

<script>
import { onBeforeMount, onMounted, ref } from "vue";
import { mapState } from "vuex";
import _ from "lodash";
import { getTextByRoleIdAndPalce, placeKeysMap } from "../../roleJs";

export default {
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  props: {
    roleId: {
      type: Number,
      default: NaN,
    },
    skillData: {
        type: Array,
        default: () => {
            return []
        },
    },
  },
  watch: {
    skillData: {
      handler(value) {
        if(value?.length > 0){
            this.showSkillGroup = value;
            console.log('getSkillData: ', value);
        }
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
          this.initHandle(value);
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props) {
    const { id, roleId} = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const tableData = ref([]);
    const currentShow = ref(1);
    const showSkillGroup = ref(
        [
            {
                labelName: 'Crystallization',
                labelUrl: require('@/assets/images/YuliApp/guiderole/icon_Skill.png'),
                content: 'Purifiers must handle each Terra with utmost care to avoid triggering unknown issues. As the most outstanding member of the Purifiers, this character can move freely around the Terra and collect rare resources. '
            }
        ]
    );
    const showTableBottomDesc = ref('');

    const initHandle = (localesPackageLocal) => {
        // 常规表格标题修改
        const getTableOption = getTextByRoleIdAndPalce(roleId, placeKeysMap.skill.talbe_data) || [];
        const tableDataLocal = _.cloneDeep(getTableOption);
        if(tableDataLocal?.length > 0){
          tableDataLocal[0][0] = localesPackageLocal?.['h5_guide_tablehead_gv']?.[localesEnv.value];
          tableDataLocal[0][1] = localesPackageLocal?.['h5_guide_tablehead_sv']?.[localesEnv.value];
          tableData.value = tableDataLocal;
        }
        // 其他内容修改
        const getKey = getTextByRoleIdAndPalce(roleId, placeKeysMap.skill.table_bottom_desc1);
        showTableBottomDesc.value = localesPackage.value?.[getKey]?.[localesEnv.value];
    }


    return {
      initHandle,
      currentShow,
      showSkillGroup,
      showTableBottomDesc,
      tableData,
      localesPackage,
      localesEnv,
    };
  },
};
</script>

<style lang="less" scoped>
.skill{
    box-sizing: border-box;
    padding: 0 24px;
    width: 100%;
    color: rgba(255,255,255,0.7);
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: left;
    padding-bottom: 25%;

    &-section{
        margin-bottom: 28px;
        line-height: 20px;
    }

    &-label{
        width: 100%;
        height: 44px;
        margin-bottom: 4px;
        position: relative;
        img{
            position: absolute;
            left: -6px;
            top: 50%;
            transform: translate(0,-50%);
            width: 44px;
            height: 44px;
            margin-right: 2px;
        }
        span{
            position: absolute;
            left: 40px;
            top: 50%;
            transform: translate(0,-40%);
            width: fit-content;
            height: 28px;
            color: #f5f5f5;
            font-size: 20px;
            font-weight: 600;
            font-family: "PingFang SC";
            text-align: left;
        }
    }
}
.table{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    .row{
        flex: 1;
        padding: 6px 10px;
        background-color: rgba(72, 85, 118, 0.5);
        border-bottom: solid 2px rgba(136, 151, 182, 0.9);
    }
    .row:nth-child(1){
        border-right: solid 2px rgba(136, 151, 182, 0.9);
    }
    .odd{
        background-color: rgba(72, 85, 118, 0.25);
    }
}
.table:last-child{
    .row{
        border-bottom: unset;
    }
}
</style>